<!-- Popover with code && desc -->
<ng-template #popoverCodeDesc
  let-code="code"
  let-desc="desc">
  {{ code }} - {{ desc }}
</ng-template>

<!-- Popover with desc only -->
<ng-template #popoverDesc
  let-desc="desc">
  {{ desc }}
</ng-template>

<div class="details-wrapper">

  @if (!nonprofitDetails) {
    <div class="row">
      <div class="col-lg-12 message">
        <img src="./assets/img/placeholders/no-data-or-tables-to-display.svg"
          [alt]="'common:lblNoResultsFound' | ycI18n: 'No results found'"/>
        <div>
          {{ noResultsFound }}
        </div>
      </div>
    </div>
  }

  @if (!!nonprofitDetails) {
    <div class="row pb-3">
      <!-- DISBURSEMENT INFORMATION -->
      <div class="col-md-4">
        <div class="show-more-details">
          <div class="more-details-header">
            <yc-i18n
              key="accountSetup:hdrDisbursementInformation"
              defaultValue="Disbursement Information">
            </yc-i18n>
          </div>
          <!-- HAS PROCESSING PARTNER  -->
          @if (nonprofitDetails.processingPartner) {
            <dl class="dl-horizontal">
              <dt class="left-col">
                <yc-i18n
                  key="nonprofits:textProcessingPartner"
                  defaultValue="Processing partner">
                </yc-i18n>
              </dt>
              <dd class="right-col">
                {{ nonprofitDetails.processingPartner }}
              </dd>
            </dl>
          }
          <!-- HAS ACH  -->
          <ng-container>
            <dl class="dl-horizontal">
              <dt class="left-col">
                <yc-i18n
                  key="nonprofits:textACH"
                  defaultValue="ACH">
                </yc-i18n>
              </dt>
              <dd class="left-col">
                <yc-fa
                [icon]="nonprofitDetails.hasAchInfo ?
                  'check-circle' :
                  'times-circle'"
                  [class.text-success]="nonprofitDetails.hasAchInfo"
                  [class.text-danger]="!nonprofitDetails.hasAchInfo">
                </yc-fa>
                <yc-i18n
                [key]="nonprofitDetails.hasAchInfo ?
                  'common:textYes' :
                  'common:textNo'">
                </yc-i18n>
              </dd>
            </dl>
          </ng-container>
          <!-- HAS BBIP  -->
          <ng-container>
            <dl class="dl-horizontal">
              <dt class="left-col">
                <yc-i18n
                  key="nonprofits:textBBIP"
                  defaultValue="BBIP">
                </yc-i18n>
              </dt>
              <dd class="left-col">
                <yc-fa
                  [icon]="nonprofitDetails.bbmsMerchantAccountExists ?
                    'check-circle' :
                    'times-circle'"
                  [class.text-success]="nonprofitDetails.bbmsMerchantAccountExists"
                  [class.text-danger]="!nonprofitDetails.bbmsMerchantAccountExists">
                </yc-fa>
                @if (nonprofitDetails.bbmsMerchantAccountExists && nonprofitDetails.expeditedGivingExists) {
                  <yc-i18n
                    key="nonprofits:textYesEGEnabled"
                    defaultValue="Yes, EG Enabled">
                  </yc-i18n>
                } @else if (nonprofitDetails.bbmsMerchantAccountExists && !nonprofitDetails.expeditedGivingExists) {
                  <yc-i18n
                    key="nonprofits:textYesEGNotEnabled"
                    defaultValue="Yes, EG not Enabled">
                  </yc-i18n>
                } @else {
                  <yc-i18n
                    key="common:textNo"
                    defaultValue="No">
                  </yc-i18n>
                }
              </dd>
            </dl>
          </ng-container>
          <!-- ADDRESS  -->
          @if (nonprofitDetails.processingPartner === bbgfText) {
            <dl class="dl-horizontal">
              <dt class="left-col">
                <yc-i18n
                  key="common:textAddress"
                  defaultValue="Address">
                </yc-i18n>
              </dt>
              <dd class="left-col">
                <div>
                  {{ nonprofitDetails?.remittanceInfo?.name }}
                </div>
                <div
                  [innerHTML]="(nonprofitDetails?.remittanceInfo?.address | address : false : true) | escapeHtml">
                </div>
                @if (nonprofitDetails?.remittanceInfo?.addressIsRegisteredAddress) {
                  <div
                    class="small">
                    <yc-i18n
                      key="nonprofit:textAddressIsRegisteredAddress"
                      defaultValue="NOTE: This address is the nonprofit's registered address">
                    </yc-i18n>
                  </div>
                }
              </dd>
            </dl>
          }
        </div>
      </div>
      <!-- REGISTRATION AUTHORITY ATTRS -->
      <div class="col-md-4">
        <div class="show-more-details">
          <div class="more-details-header">
            <yc-i18n
              key="nonprofits:textRegistrationAuthorityAttributes"
              defaultValue="Registration Authority Attributes">
            </yc-i18n>
          </div>
          <!-- FOR SPECIAL CASES - HDS & CT  -->
          @if (regAuthIdsExcluded.includes(nonprofitDetails.registrationAuthorityId)) {
            <!-- CT - Reference Code  -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.Reference_Code :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="left-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.Reference_Code :
                  false :
                  false
                  }}
                </dt>
                <dd class="left-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.Reference_Code :
                  false :
                  true
                  }}
                </dd>
              </dl>
            }
            <!-- TS ID  -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.TS_ID :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="right-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.TS_ID :
                  false :
                  false :
                  false
                  }}
                </dt>
                <dd class="right-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.TS_ID :
                  false :
                  true
                  }}
                </dd>
              </dl>
            }
            <!-- ACTIVE ON TS  -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.Active_TS :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="right-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.Active_TS :
                  false :
                  false
                  }}
                </dt>
                <dd class="right-col">
                  <yc-fa
              [icon]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_TS :
                  true :
                  false) ?
                  'check-circle' :
                  'times-circle'"
              [class.text-success]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_TS :
                  true :
                  false)"
              [class.text-danger]="!(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_TS :
                  true :
                  false)">
                  </yc-fa>
                  <yc-i18n
              [key]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_TS :
                  true :
                  false) ?
                  'common:textYes' :
                  'common:textNo'">
                  </yc-i18n>
                </dd>
              </dl>
            }
            <!-- FP ID  -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.FP_ID :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="right-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.FP_ID :
                  false :
                  false :
                  false
                  }}
                </dt>
                <dd class="right-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.FP_ID :
                  false :
                  true
                  }}
                </dd>
              </dl>
            }
            <!-- ACTIVE ON FP  -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.Active_FP :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="right-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.Active_FP :
                  false :
                  false
                  }}
                </dt>
                <dd class="right-col">
                  <yc-fa
              [icon]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_FP :
                  true :
                  false) ?
                  'check-circle' :
                  'times-circle'"
              [class.text-success]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_FP :
                  true :
                  false)"
              [class.text-danger]="!(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_FP :
                  true :
                  false)">
                  </yc-fa>
                  <yc-i18n
              [key]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.Active_TS :
                  true :
                  false) ?
                  'common:textYes' :
                  'common:textNo'">
                  </yc-i18n>
                </dd>
              </dl>
            }
          }
          <!-- ALL OTHER CASES  -->
          @if (!(regAuthIdsExcluded.includes(nonprofitDetails.registrationAuthorityId))) {
            <!-- ON IRS BMF -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.On_IRS_BMF :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.On_IRS_BMF :
                  false :
                  false
                  }}
                  @if (nonprofitDetails | nppRegAuthAttrs:
                    RegAuthAttrDefaultValue.On_IRS_BMF :
                    false :
                    false) {
                    <button
                      class="popover-link"
                      [attr.aria-label]="'common:btnInfo' | ycI18n"
                      [popover]="popoverDesc"
              [popoverContext]="{
                desc: onBmfPopover
              }"
                      [outsideClick]="true"
                      [placement]="'right'">
                      <yc-fa class="text-link ms-2 icon-popover"
                        icon="info-circle"
                        [light]="true">
                      </yc-fa>
                    </button>
                  }
                </dt>
                <dd class="middle-col">
                  <yc-fa
              [icon]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.On_IRS_BMF :
                  true :
                  false) ?
                  'check-circle' :
                  'times-circle'"
              [class.text-success]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.On_IRS_BMF :
                  true :
                  false)"
              [class.text-danger]="!(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.On_IRS_BMF :
                  true :
                  false)">
                  </yc-fa>
                  <yc-i18n
              [key]="(nonprofitDetails | nppRegAuthAttrs:
                RegAuthAttrDefaultValue.On_IRS_BMF :
                  true :
                  false) ?
                  'common:textYes' :
                  'common:textNo'">
                  </yc-i18n>
                </dd>
              </dl>
            }
            <!-- DEDUCTIBILITY CODE -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.BMF_Deductibility_code :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.BMF_Deductibility_code :
                  false :
                  false
                  }}
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    [popover]="popoverCodeDesc"
              [popoverContext]="{
                code: (nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.BMF_Deductibility_code :
                    false :
                    true),
                desc: (nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.DeductibilityCodeDesc :
                    false :
                    true)
              }"
                    [outsideClick]="true"
                    [placement]="'right'">
                    <yc-fa class="text-link ms-2 icon-popover"
                      icon="info-circle"
                      [light]="true">
                    </yc-fa>
                  </button>
                </dt>
                <dd class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.BMF_Deductibility_code :
                  false:
                  true
                  }}
                </dd>
              </dl>
            }
            <!-- BMF SUBSECTION -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.BMF_Subsection_code :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.BMF_Subsection_code :
                  false :
                  false
                  }}
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    (click)="openIrsCodesModal(CodeType.BMFSubsection)">
                    <yc-fa class="text-link ms-2 icon-popover"
                      icon="info-circle"
                      [light]="true">
                    </yc-fa>
                  </button>
                </dt>
                <dd class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.BMF_Subsection_code :
                  false:
                  true
                  }}
                </dd>
              </dl>
            }
            <!-- BMF FOUNDATION -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.BMF_Foundation_code :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.BMF_Foundation_code :
                  false :
                  false
                  }}
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    (click)="openIrsCodesModal(CodeType.BMFFoundation)">
                    <yc-fa class="text-link ms-2 icon-popover"
                      icon="info-circle"
                      [light]="true">
                    </yc-fa>
                  </button>
                </dt>
                <dd class="middle-col">
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    [popover]="popoverCodeDesc"
                [popoverContext]="{
                  code: (nonprofitDetails | nppRegAuthAttrs:
                    RegAuthAttrDefaultValue.BMF_Foundation_code :
                      false :
                      true),
                  desc: (nonprofitDetails | nppRegAuthAttrs:
                    RegAuthAttrDefaultValue.FoundationCodeDesc :
                      false :
                      true)
                }"
                    [outsideClick]="true"
                    [placement]="'right'">
                    <span class="text-link">
                      {{ nonprofitDetails | nppRegAuthAttrs:
                      RegAuthAttrDefaultValue.BMF_Foundation_code :
                      false:
                      true
                      }}
                    </span>
                  </button>
                </dd>
              </dl>
            }
            <!-- ON PUB 78 -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.On_IRS_Pub_78 :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.On_IRS_Pub_78 :
                  false :
                  false
                  }}
                  @if (nonprofitDetails | nppRegAuthAttrs:
                    RegAuthAttrDefaultValue.On_IRS_Pub_78 :
                    false :
                    false) {
                    <button
                      [attr.aria-label]="'common:btnInfo' | ycI18n"
                      class="popover-link"
                      [popover]="popoverDesc"
                [popoverContext]="{
                  desc: onPub78Popover
                }"
                      [outsideClick]="true"
                      [placement]="'right'">
                      <yc-fa class="text-link ms-2 icon-popover"
                        icon="info-circle"
                        [light]="true">
                      </yc-fa>
                    </button>
                  }
                </dt>
                <dd class="middle-col">
                  <yc-fa
                [icon]="(nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.On_IRS_Pub_78 :
                    true :
                    false) ?
                    'check-circle' :
                    'times-circle'"
                [class.text-success]="(nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.On_IRS_Pub_78 :
                    true :
                    false)"
                [class.text-danger]="!(nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.On_IRS_Pub_78 :
                    true :
                    false)">
                  </yc-fa>
                  <yc-i18n
                [key]="(nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.On_IRS_Pub_78 :
                    true :
                    false) ?
                    'common:textYes' :
                    'common:textNo'">
                  </yc-i18n>
                </dd>
              </dl>
            }
            <!-- PUB 78 DESIGNATION CODE -->
            @if (nonprofitDetails | nppRegAuthAttrs:
              RegAuthAttrDefaultValue.Pub78_Designation_code :
              false :
              false) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.Pub78_Designation_code :
                  false :
                  false
                  }}
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    (click)="openIrsCodesModal(CodeType.Pub78Designation)">
                    <yc-fa class="text-link ms-2 icon-popover"
                      icon="info-circle"
                      [light]="true">
                    </yc-fa>
                  </button>
                </dt>
                <dd class="middle-col">
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    [popover]="popoverCodeDesc"
                [popoverContext]="{
                  code: (nonprofitDetails | nppRegAuthAttrs:
                    RegAuthAttrDefaultValue.ExemptStatusCode :
                      false :
                      true),
                  desc: (nonprofitDetails | nppRegAuthAttrs:
                    RegAuthAttrDefaultValue.PubExemptStatusCodeDesc:
                      false :
                      true)
                }"
                    [outsideClick]="true"
                    [placement]="'right'">
                    <span class="text-link">
                      {{ nonprofitDetails | nppRegAuthAttrs:
                      RegAuthAttrDefaultValue.Pub78_Designation_code :
                      false:
                      true
                      }}
                    </span>
                  </button>
                </dd>
              </dl>
            }
            <!-- NTEE/CLASSIFICATION- KEEP FORMAT -->
            @if (!!nonprofitDetails.nonprofitClassification) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  <yc-i18n
                    key="nonprofit:textNonprofitClassificationNTEE"
                    defaultValue="Nonprofit classification (NTEE)">
                  </yc-i18n>
                </dt>
                <dd class="middle-col">
                  {{ nonprofitDetails.nonprofitClassification }}
                </dd>
              </dl>
            }
            <!-- REVOCATION DATE  -->
            @if (showRevocationDate) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.IRS_Revocation_Date :
                  false :
                  false
                  }}
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    [popover]="popoverDesc"
                [popoverContext]="{
                  desc: irsRevocationPopover
                }"
                    [outsideClick]="true"
                    [placement]="'auto'">
                    <yc-fa class="text-link ms-2 icon-popover"
                      icon="info-circle"
                      [light]="true">
                    </yc-fa>
                  </button>
                </dt>
                <dd class="middle-col">
                  @if (irsRevocationActive) {
                    <button class="popover-link"
                      [attr.aria-label]="'common:btnInfo' | ycI18n"
                      (click)="openRevocationDetailsByStateModal()">
                      <span class="text-link">
                        {{ nonprofitDetails | nppRegAuthAttrs:
                        RegAuthAttrDefaultValue.IRS_Revocation_Date :
                        false:
                        true
                        }}
                      </span>
                    </button>
                  }
                  @if (!irsRevocationActive) {
                    <span class="text-link">
                      {{ nonprofitDetails | nppRegAuthAttrs:
                      RegAuthAttrDefaultValue.IRS_Revocation_Date :
                      false:
                      true
                      }}
                    </span>
                  }
                </dd>
              </dl>
            }
            <!-- REVOCATION STATES  -->
            @if (showRevocationDate) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  {{ nonprofitDetails | nppRegAuthAttrs:
                  RegAuthAttrDefaultValue.US_State_Revocations :
                  false :
                  false
                  }}
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    [popover]="popoverDesc"
                [popoverContext]="{
                  desc: usStatRevocationsPopover
                }"
                    [outsideClick]="true"
                    [placement]="'auto'">
                    <yc-fa class="text-link ms-2 icon-popover"
                      icon="info-circle"
                      [light]="true">
                    </yc-fa>
                  </button>
                </dt>
                <dd class="middle-col">
                  @if (stateRevocationActive) {
                    <button class="popover-link"
                      [attr.aria-label]="'common:btnInfo' | ycI18n"
                      (click)="openRevocationDetailsByStateModal()">
                      <span class="text-link">
                        {{ nonprofitDetails | nppRegAuthAttrs:
                        RegAuthAttrDefaultValue.US_State_Revocations :
                        false:
                        true
                        }}
                      </span>
                    </button>
                  }
                  @if (!stateRevocationActive) {
                    <span class="text-link">
                      {{ nonprofitDetails | nppRegAuthAttrs:
                      RegAuthAttrDefaultValue.US_State_Revocations :
                      false:
                      true
                      }}
                    </span>
                  }
                </dd>
              </dl>
            }
            <!-- REG AUTH ATTR MODAL LINK  -->
            @if (showRevocationDate) {
              <dl
                class="dl-horizontal">
                <dt class="middle-col">
                  <yc-i18n
                    key="nonprofit:textAttributeHistory"
                    defaultValue="Attribute History">
                  </yc-i18n>
                </dt>
                <dd class="middle-col">
                  <button class="popover-link"
                    [attr.aria-label]="'common:btnInfo' | ycI18n"
                    (click)="openIrsAttributionModal()">
                    <span class="text-link">
                      <yc-i18n
                        key="nonprofit:linkViewHistory"
                        defaultValue="View history">
                      </yc-i18n>
                    </span>
                  </button>
                </dd>
              </dl>
            }
          }
        </div>
      </div>
      <!-- ADDITIONAL INFORMATION -->
      <div class="col-md-4">
        <div class="show-more-details">
          <div class="more-details-header">
            <yc-i18n
              key="common:hdrAdditionalInformation"
              defaultValue="Additional Information">
            </yc-i18n>
          </div>
          <ng-container>
            <!-- ACTIVE ADMINS  -->
            <dl class="dl-horizontal">
              <dt class="middle-col">
                <yc-i18n key="nonprofits:textActiveAdministratorsNumber"
                         defaultValue="Active administrators">
                </yc-i18n>
              </dt>
              <dd class="middle-col">
                @if (numOfAdmins > 0) {
                <a href="javascript:void(0)"
                   class="text-info"
                   [attr.aria-label]="'common:btnInfo' | ycI18n"
                   (click)="openActiveAdminsModal(activeUsers)">
                  {{ numOfAdmins }}
                </a>
                }
                @if (numOfAdmins === 0) {
                <span>
                  {{ numOfAdmins }}
                </span>
                }
              </dd>
              <!-- ACTIVE VETTING  -->
              <dt class="middle-col">
                <yc-i18n key="nonprofits:textActiveVetting"
                         defaultValue="Active vetting">
                </yc-i18n>
              </dt>
              <dd class="middle-col">
                @for (vetting of nonprofitDetails.activeVetting; track $index) {
                  <div class="mb-2">
                    {{ vetting.name| nppActiveVetting : vetting.expiration }}
                  </div>
                }
            </dd>
              <!-- ACTIVE COMPLIANCE  -->
              <dt class="middle-col">
                <yc-i18n key="nonprofits:textActiveCompliance"
                         defaultValue="Active compliance">
                </yc-i18n>
              </dt>
              <dd class="middle-col">
                @if (canImpersonateNonprofit) {
                <a href="javascript:void(0)"
                   class="text-info"
                   [attr.aria-label]="'common:btnInfo' | ycI18n"
                   [tooltip]="goToCompliance"
                   [tooltipPlacement]="'top'"
                   (click)="routeToCompliance(nonprofitId)">
                  {{ nonprofitDetails.activeCompliances }}
                </a>
                }
                @if (!canImpersonateNonprofit) {
                <span>
                  {{ nonprofitDetails.activeCompliances }}
                </span>
                }
              </dd>
              <!-- NOTES  -->
              <dt class="middle-col">
                <yc-i18n key="nonprofits:textNotesLink"
                         defaultValue="Notes:">
                </yc-i18n>
              </dt>
              <dd class="middle-col">
                @if (canImpersonateNonprofit &&
                notesCount > 0) {
                <a href="javascript:void(0)"
                   class="text-info"
                   [attr.aria-label]="'common:btnInfo' | ycI18n"
                   [tooltip]="goToNotes"
                   [tooltipPlacement]="'top'"
                   (click)="routeToNotes(nonprofitId)">
                  {{ notesCount }}
                </a>
                }
                @if (!canImpersonateNonprofit ||
                notesCount < 1) {
                <span>
                  {{ notesCount }}
                </span>
                }
              </dd>
            </dl>
          </ng-container>
        </div>
      </div>
    </div>
  }
</div>
